import type { EvalCompareSummary, EvalResultSeries } from "./evalCompareModel";

/** 선택한 축이 실제로 측정된 시리즈만 남긴다. */
export function measuredSeries(
  items: readonly EvalResultSeries[],
  select: (summary: EvalCompareSummary) => number | null,
): EvalResultSeries[] {
  return items.filter((item) => select(item.summary) !== null);
}

export function fitDomain(values: readonly number[]): [number, number] {
  if (values.length === 0) return [0, 1];
  const low = Math.min(...values);
  const high = Math.max(...values);
  const pad = (high - low) * 0.15 || Math.max(high * 0.05, 0.01);
  return [Math.max(0, low - pad), high + pad];
}

export function fitDurationDomain(values: readonly number[]): [number, number] {
  const high = Math.max(...values, 0);
  return [0, high > 0 ? high * 1.15 : 1];
}
